import { Calculation } from 'final-form-calculate'
import { MetaPath } from 'util/metaPath'
import { EscutaInicialState } from 'view/atendimentos/escuta-inicial/model-escutaInicial'

import { SoapState } from '../../atendimento-individual/model'
import { SinaisVitaisAccordionModel } from './SinaisVitaisAccordion'

export const createSinaisVitaisCalculations = (meta: MetaPath<SinaisVitaisAccordionModel>): Calculation[] => [
  {
    field: meta.glicemia.absolutePath(),
    updates: {
      [meta.tipoGlicemia.absolutePath()]: (glicemiaValue: string, allValues: SoapState) =>
        glicemiaValue && allValues.objetivo.sinaisVitais.tipoGlicemia,
    },
  },
]

export const createSinaisVitaisEscutaCalculations = (meta: MetaPath<SinaisVitaisAccordionModel>): Calculation[] => [
  {
    field: meta.glicemia.absolutePath(),
    updates: {
      [meta.tipoGlicemia.absolutePath()]: (glicemiaValue: string, allValues: EscutaInicialState) =>
        glicemiaValue && allValues.sinaisVitais.tipoGlicemia,
    },
  },
]
